import { render } from "./UserSubsIndex.vue?vue&type=template&id=0f350a0b"
import script from "./UserSubsIndex.vue?vue&type=script&lang=js"
export * from "./UserSubsIndex.vue?vue&type=script&lang=js"

import exportComponent from "/home/marco/keyos-projects/esamiFinanza/webapp-esamifinanza/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__